(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/collections/my-receivers.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/collections/my-receivers.js');
(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.collections.MyReceivers = Backbone.Collection.extend({
    url:
      svs.core.jupiter.url() +
      '/player/1/sponsorship/receiverselection?active=true',

    initialize: function() {
      this.reset(svs.grassroots.data.myReceivers || []);
    },

    parse: function(response) {
      _.each(response.receivers, function(receiver) {
        receiver.myReceiver = true;
      });
      return response.receivers;
    },
    checkModel: function(model) {
      var tmpModel = model;
      if (typeof model === 'number') {
        _.find(this.models, function(internalModel) {
          if (internalModel.get('id') === model) {
            tmpModel = internalModel;
            return true;
          }
          return false;
        });
      }
      return tmpModel;
    },
    addSupport: function(model, el) {
      model = this.checkModel(model);
      var self = this;
      var options = {
        method: 'POST',
        path: '/player/1/sponsorship/receiverselection',
        data: {
          receivers: [model.get('id')]
        }
      };
      var name = model.get('longname');
      options.data.omsKey = svs.grassroots.helpers.getOmsKey();
      svs.ui.loader.show();
      svs.core.jupiter.call(
        options,
        function(response) {
          svs.ui.loader.hide();
          svs.grassroots.helpers.dialog.infoToaster({
            title: 'Grattis',
            message: `Nu stödjer du ${name}.`
          });
          _.each(response.receivers, function(receiver) {
            receiver.myReceiver = true;
          });
          self.set(response.receivers);
          self.trigger('change');
          var evt = {
            category: 'Gräsroten',
            action: 'Ge mitt stöd',
            opt_label: name
          };
          svs.components.analytics.trackEvent(evt);
        },
        function(err) {
          svs.ui.loader.hide();
          var error = JSON.parse(err.responseText).error;
          switch (error.code) {
            case 10002: 
              if (
                _.find(self.models, function(myReceiver) {
                  return myReceiver.get('id') === model.get('id');
                })
              ) {
                svs.grassroots.helpers.dialog.errorToaster({
                  title: 'Fel',
                  message: `Du stödjer redan ${name}.`
                });
              } else {
                var replaceReceiverModel = new svs.grassroots.models.ReplaceReceiver(
                  { currentReceivers: self.models, receiverToAdd: [model] },
                  { collection: self }
                );
                replaceReceiverModel.replaceSupport = self.replaceSupport;
                var replaceReceiverView = new svs.grassroots.views.ReplaceReceiver({ model: replaceReceiverModel });
                const receiverRoot = el.querySelector('.replace-receiver-root');
                el.querySelector('.js-add-support-btn').hidden = true;
                receiverRoot.appendChild(replaceReceiverView.render().el);
              }
              break;
            case 10004:
              svs.grassroots.helpers.dialog.errorToaster({
                title: 'Fel',
                message: `Du stödjer redan ${name}.`
              });
              break;
            default:
              svs.grassroots_logger.error(
                'Set support for receiver error',
                svs.core.jupiter.parseErrorResponse(err)
              );
              svs.grassroots.helpers.dialog.errorPopup({
                title: 'Fel',
                message: `Kunde inte spara stöd till: ${name}. Försök igen senare.`
              });
          }
        }
      );
    },
    removeSupport: function(model) {
      model = this.checkModel(model);
      var name = model.get('longname');
      var id = model.get('id');
      var self = this;
      var options = {
        method: 'DELETE',
        path: '/player/1/sponsorship/receiverselection',
        data: {
          receivers: [id]
        }
      };
      svs.ui.loader.show();
      svs.core.jupiter.call(
        options,
        function(response) {
          svs.ui.loader.hide();
          svs.grassroots.helpers.dialog.infoToaster({
            title: 'Avslutat',
            message: `Du har avslutat ditt stöd till ${name}`
          });
          _.each(response.receivers, function(receiver) {
            receiver.myReceiver = true;
          });
          self.set(response.receivers);
          self.trigger('change');
          var evt = {
            category: 'Gräsroten',
            action: 'Avsluta mitt stöd',
            opt_label: name
          };
          svs.components.analytics.trackEvent(evt);
        },
        function(error) {
          svs.grassroots_logger.warn(
            'Delete support for receiver error',
            svs.core.jupiter.parseErrorResponse(error)
          );
          svs.ui.loader.hide();
          svs.grassroots.helpers.dialog.errorPopup({
            title: 'Fel',
            message: `Kunde inte avsluta stöd till ${name}. Försök igen senare`
          });
        }
      );
    },
    removeFromList: function(id) {
      var self = this;
      var receiver = self.find(function(model) {
        return model.id === id;
      });
      self.remove(receiver);
    },
    addList: function(list) {
      this.reset(list);
    },
    replaceSupport: function(
      receiverToAddId,
      receiverToRemoveId,
      receiverToAddName
    ) {
      var options = {
        method: 'PUT',
        path: '/player/1/sponsorship/receiverselection',
        data: {
          receiverToAdd: receiverToAddId,
          receiverToRemove: receiverToRemoveId
        }
      };
      var self = this.collection;
      options.data.omsKey = svs.grassroots.helpers.getOmsKey();
      svs.ui.loader.show();
      svs.core.jupiter.call(
        options,
        function(response) {
          _.each(response.receivers, function(receiver) {
            receiver.myReceiver = true;
          });
          self.set(response.receivers);
          svs.ui.loader.hide();
          svs.grassroots.helpers.dialog.infoToaster({
            title: 'Tack',
            message: `Nu stödjer du ${receiverToAddName}.`
          });
        },
        function(err) {
          var error = JSON.parse(err.responseText).error;
          svs.ui.loader.hide();
          switch (error.code) {
            case 10004: 
              svs.grassroots_logger.debug(
                'Set support for receiver error',
                svs.core.jupiter.parseErrorResponse(err)
              );
              svs.grassroots.helpers.dialog.infoToaster({
                title: 'Fel',
                message: `Du stödjer redan ${receiverToAddName}.`
              });
              break;
            default:
              svs.grassroots_logger.info(
                'Replace support for receiver error',
                svs.core.jupiter.parseErrorResponse(err)
              );
              svs.grassroots.helpers.dialog.errorPopup({
                title: `Fel`,
                message: `Kunde inte spara stöd till ${receiverToAddName}. Försök igen senare.`
              });
          }
        }
      );
    }
  });
})(Backbone, _, svs);


 })(window);